var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckServer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22C9.23858 22 7 19.7614 7 17C7 14.2386 9.23858 12 12 12C14.7614 12 17 14.2386 17 17C17 19.7614 14.7614 22 12 22ZM15.0303 16.0303C15.3232 15.7374 15.3232 15.2626 15.0303 14.9697C14.7374 14.6768 14.2626 14.6768 13.9697 14.9697L11.5 17.4393L10.5303 16.4697C10.2374 16.1768 9.76256 16.1768 9.46967 16.4697C9.17678 16.7626 9.17678 17.2374 9.46967 17.5303L10.9697 19.0303C11.2626 19.3232 11.7374 19.3232 12.0303 19.0303L15.0303 16.0303Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 4C2 2.89543 2.89543 2 4 2H20C21.1046 2 22 2.89543 22 4V9.25H2V4ZM5 3.75C4.58579 3.75 4.25 4.08579 4.25 4.5V6.5C4.25 6.91421 4.58579 7.25 5 7.25C5.41421 7.25 5.75 6.91421 5.75 6.5V4.5C5.75 4.08579 5.41421 3.75 5 3.75ZM8 3.75C7.58579 3.75 7.25 4.08579 7.25 4.5V6.5C7.25 6.91421 7.58579 7.25 8 7.25C8.41421 7.25 8.75 6.91421 8.75 6.5V4.5C8.75 4.08579 8.41421 3.75 8 3.75ZM12 4.75C11.5858 4.75 11.25 5.08579 11.25 5.5C11.25 5.91421 11.5858 6.25 12 6.25H19C19.4142 6.25 19.75 5.91421 19.75 5.5C19.75 5.08579 19.4142 4.75 19 4.75H12Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 16V10.75H10.2086C7.4899 11.5278 5.5 14.0315 5.5 17C5.5 17.3401 5.52611 17.674 5.57645 18H4C2.89543 18 2 17.1046 2 16Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4236 18H20C21.1046 18 22 17.1046 22 16V10.75H13.7914C16.5101 11.5278 18.5 14.0315 18.5 17C18.5 17.3401 18.4739 17.674 18.4236 18Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckServer);
export default __webpack_public_path__ + "static/media/check-server.9e87dd88e807f08696a75ecd2232f70c.svg";
export { ForwardRef as ReactComponent };